<template>
  <div class="col-lg-12">
    <div class="hpanel">
      <br />
      <div class="panel-body">
        <div>
          <v-tabs v-model="active" slider-color="primary">
            <v-tab key="gate_step_1" ripple>
              <small>Step 1 - School/Organization Details</small>
            </v-tab>
            <v-tab key="gate_step_2" ripple>
              <small>Step 2 - Residency</small>
            </v-tab>
            <v-tab key="gate_step_3" ripple>
              <small>Step 3 - Vehicle Entry Fees</small>
            </v-tab>
            <v-tab key="gate_step_4" ripple>
              <small>Step 4 - Accommodation/Camping</small>
            </v-tab>
            <v-tab key="gate_step_5" ripple>
              <small>Step 5 - Activities</small>
            </v-tab>
            <v-tab v-if="proofOfResidency.length > 0" key="gate_step_7" ripple>
              <small>Step 6 - Proof of Residency</small>
            </v-tab>
            <v-tab key="gate_step_6" ripple>
              <small>Step 6 - Approval</small>
            </v-tab>
            <v-tab-item key="gate_step_1">
              <v-card flat>
                <v-layout row wrap>
                  <v-flex lg12 md12 sm12 xs12>
                    <v-container fluid>
                      <v-select
                        label="Booking Type *"
                        v-model="gate_pass.organisation_type"
                        :items="organizationTypes"
                        :rules="[(v) => !!v || 'Item is required']"
                        required
                        item-text="booking_type_name"
                        item-value="booking_type_public_id"
                        :loading="$loadingTrue"
                      ></v-select>
                    </v-container>
                  </v-flex>
                  <v-flex lg6 md6 sm12 xs12>
                    <v-container>
                      <v-dialog
                        ref="dialog"
                        persistent
                        v-model="modal1"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="gate_pass.check_in"
                      >
                        <v-text-field
                          slot="activator"
                          label="Check-in"
                          v-model="gate_pass.check_in"
                          readonly
                        ></v-text-field>
                        <v-date-picker
                          v-model="gate_pass.check_in"
                          :min="start_date"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="modal1 = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="$refs.dialog.save(gate_pass.check_in)"
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-container>
                  </v-flex>
                  <v-flex lg6 md6 sm12 xs12>
                    <v-container>
                      <v-dialog
                        ref="dialog1"
                        persistent
                        v-model="modal2"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="gate_pass.check_out"
                      >
                        <v-text-field
                          slot="activator"
                          label="Check-out"
                          v-model="gate_pass.check_out"
                          readonly
                        ></v-text-field>
                        <v-date-picker
                          v-model="gate_pass.check_out"
                          :min="gate_pass.check_in"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="modal2 = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="$refs.dialog1.save(gate_pass.check_out)"
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-container>
                  </v-flex>
                  <v-flex lg8 md12 sm12 xs12>
                    <v-container fluid>
                      <v-autocomplete
                        label="Destination *"
                        v-model="gate_pass.destination"
                        :items="allDestinations"
                        :rules="[(v) => !!v || 'Item is required']"
                        required
                        item-text="destination_name"
                        item-value="destination_public_id"
                        :loading="$loadingTrue"
                        @change="checkDestination"
                      ></v-autocomplete>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md6 sm12 xs12>
                    <v-container>
                      <v-autocomplete
                        label="Country *"
                        v-model="gate_pass.code"
                        :items="allCountries"
                        :rules="[(v) => !!v || 'Country is required']"
                        required
                        item-text="name"
                        item-value="code"
                        @change="findCountryCode"
                        :loading="$loadingTrue"
                      ></v-autocomplete>
                    </v-container>
                  </v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  v-if="gate_pass.organisation_type === 'C3237489'"
                >
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        label="Organization Name *"
                        v-model="gate_pass.organisation_name"
                        :rules="requiredRules"
                        required
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        label="Organization Email *"
                        v-model="gate_pass.organisation_email"
                        :rules="requiredRules"
                        required
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        label="Contact Person's Name *"
                        v-model="gate_pass.name"
                        :rules="requiredRules"
                        required
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        label="Contact Person's Email *"
                        v-model="gate_pass.email"
                        :rules="requiredRules"
                        required
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        label="Contact Person's Phone Number *"
                        v-model="gate_pass.phone"
                        required
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  v-if="gate_pass.organisation_type === '8D7E6504'"
                >
                  <v-flex lg4 md4 sm12 xs12>
                      <v-container>
      <v-autocomplete
        label="Select School *"
        v-model="gate_pass.school.school_id"
        :items="$allSchools"
        :rules="[(v) => !!v || 'Item is required']"
        required
        item-text="school_name"
        item-value="school_public_id"
        @change="onSchoolSelect"
      ></v-autocomplete>
    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        label="Primary Contact Name *"
                        v-model="gate_pass.school.primary_contact"
                        :rules="requiredRules"
                        required
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        label="Primary Contact Email *"
                        v-model="gate_pass.school.primary_contact_email"
                        :rules="requiredRules"
                        required
                        type="email"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        label="Primary Contact Phone *"
                        v-model="gate_pass.school.primary_contact_phone"
                        :rules="requiredRules"
                        required
                        type="tel"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        label="Secondary Contact Name"
                        v-model="gate_pass.school.secondary_contact"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        label="Secondary Contact Email"
                        v-model="gate_pass.school.secondary_contact_email"
                        type="email"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        label="Secondary Contact Phone"
                        v-model="gate_pass.school.secondary_contact_phone"
                        type="tel"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex lg12 md12 sm12 xs12>
                    <v-container fluid>
                      <v-text-field
                        v-model="gate_pass.promo_code"
                        label="Promo Code"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg6 md6 sm12 xs12>
                      <v-container fluid>
                         <v-text-field
                             v-model="gate_pass.kra_pin_number"
                             label="KRA Pin"
                         ></v-text-field>
                      </v-container>
                  </v-flex>
                  <v-flex lg12 md6 sm12 xs12>
                    <v-container fluid>
                      <v-textarea
                        v-model="gate_pass.note"
                        label="Notes"
                      ></v-textarea>
                    </v-container>
                  </v-flex>
                  <p class="text-danger">* Indicates Mandatory Fields</p>
                </v-layout>
              </v-card>
              <v-layout row wrap>
                <v-flex lg11 md11></v-flex>
                <v-flex lg1 md1 sm6 xs6>
                  <v-btn @click="nextTab()" fab round color="primary"
                    ><v-icon>navigate_next</v-icon></v-btn
                  >
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item key="gate_step_2">
              <v-card flat>
                <v-container v-if="gate_pass.organisation_type === ''">
                  <p
                    class="headline text-md-center text-lg-center error"
                    style="color: white"
                  >
                    You need to select the group type
                  </p>
                </v-container>
                <div
                  class="col-md-12"
                  v-if="gate_pass.organisation_type === '8D7E6504'"
                >
                  <table
                    cellpadding="1"
                    cellspacing="1"
                    class="table table-bordered"
                  >
                    <thead>
                      <tr>
                        <td>Residency</td>
                        <td>Currency</td>
                        <td>Amount</td>
                        <td>Guests</td>
                        <td>Discount (%)</td>
                        <td>Discount Reason</td>
                        <td>Total Amount</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(fee, key) in allSchoolConservationFees"
                        :key="key"
                      >
                        <td>{{ fee.payment_person }}</td>
                        <td>{{ $localCurrency }}</td>
                        <td>
                          {{
                            $roundOff(
                              convert1(
                                fee.payment_person_currency,
                                fee.payment_person_amount
                              ).amount
                            )
                          }}
                        </td>
                        <td>
                          <v-text-field
                            label="Number"
                            type="number"
                            min="0"
    step="1"
    oninput="this.value = Math.max(0, this.value)"
                            v-model="
                              allSchoolConservationFees[key].payment_guests
                            "
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            label="Discount (%)"
                             min="0"
    max="100"
    step="any"
    onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46"
    oninput="if(parseFloat(this.value)>100) this.value=0"
        onpaste="this.value = parseFloat(this.value.replace(/[^0-9.]/g,'')) || 0"
                            v-model="
                              allSchoolConservationFees[key]
                                .payment_person_discount
                            "
                            required
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            label="Discount Reason"
                            v-model="
                              allSchoolConservationFees[key]
                                .payment_person_discount_reason
                            "
                          ></v-text-field>
                        </td>
                        <td>
                          {{ $localCurrency }}
                          {{
                            $roundOff(
                              convert1(
                                allSchoolConservationFees[key]
                                  .payment_person_currency,
                                Number(
                                  allSchoolConservationFees[key]
                                    .payment_person_amount
                                ) *
                                  Number(
                                    allSchoolConservationFees[key]
                                      .payment_guests
                                  ) *
                                  ((100 -
                                    allSchoolConservationFees[key]
                                      .payment_person_discount) /
                                    100)
                              ).amount
                            )
                          }}
                        </td>
                        <!--<td>{{fee.payment_person_currency}} {{$roundOff(Number(allSchoolConservationFees[key].payment_person_amount) * Number(allSchoolConservationFees[key].payment_guests) * ((100 - allSchoolConservationFees[key].payment_person_discount) / 100))}}</td>-->
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                          <h3>
                            {{ $localCurrency }}
                            {{ schoolConservationTotal.toLocaleString("en") }}
                          </h3>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  class="col-md-12"
                  v-if="gate_pass.organisation_type === 'C3237489'"
                >
                  <conservation-fees
                    :check_in="gate_pass.check_in"
                    :check_out="gate_pass.check_out"
                  ></conservation-fees>
                </div>
              </v-card>
              <v-layout row wrap v-if="gate_pass.organisation_type !== ''">
                <v-flex lg1 md1 sm6 xs6>
                  <v-btn @click="previousTab()" fab round color="secondary"
                    ><v-icon>navigate_before</v-icon></v-btn
                  >
                </v-flex>
                <v-flex lg10 md10></v-flex>
                <v-flex lg1 md1 sm6 xs6>
                  <v-btn @click="nextTab()" fab round color="primary"
                    ><v-icon>navigate_next</v-icon></v-btn
                  >
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item key="gate_step_3">
              <vehicle-fees
                :check_in="gate_pass.check_in"
                :check_out="gate_pass.check_out"
              ></vehicle-fees>
              <v-layout row wrap>
                <v-flex lg1 md1 sm6 xs6>
                  <v-btn @click="previousTab()" fab round color="secondary"
                    ><v-icon>navigate_before</v-icon></v-btn
                  >
                </v-flex>
                <v-flex lg10 md10></v-flex>
                <v-flex lg1 md1 sm6 xs6>
                  <v-btn @click="nextTab()" fab round color="primary"
                    ><v-icon>navigate_next</v-icon></v-btn
                  >
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item key="gate_step_4">
              <v-card flat>
                <facility-booking></facility-booking>
              </v-card>
              <v-layout row wrap>
                <v-flex lg1 md1 sm6 xs6>
                  <v-btn @click="previousTab()" fab round color="secondary"
                    ><v-icon>navigate_before</v-icon></v-btn
                  >
                </v-flex>
                <v-flex lg10 md10></v-flex>
                <v-flex lg1 md1 sm6 xs6>
                  <v-btn @click="nextTab()" fab round color="primary"
                    ><v-icon>navigate_next</v-icon></v-btn
                  >
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item key="gate_step_5">
              <v-card flat>
                <inventory-booking></inventory-booking>
              </v-card>
              <v-layout row wrap>
                <v-flex lg1 md1 sm6 xs6>
                  <v-btn @click="previousTab()" fab round color="secondary"
                    ><v-icon>navigate_before</v-icon></v-btn
                  >
                </v-flex>
                <v-flex lg10 md10></v-flex>
                <v-flex lg1 md1 sm6 xs6>
                  <v-btn @click="nextTab()" fab round color="primary"
                    ><v-icon>navigate_next</v-icon></v-btn
                  >
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item v-if="proofOfResidency.length < 0" key="gate_step_7">
              <v-card flat>
                <residency-proof></residency-proof>
                <v-layout row wrap>
                  <v-flex lg1 md1 sm6 xs6>
                    <v-btn @click="previousTab()" fab round color="secondary"
                      ><v-icon>navigate_before</v-icon></v-btn
                    >
                  </v-flex>
                  <v-flex lg10 md10></v-flex>
                  <v-flex lg1 md1 sm6 xs6>
                    <v-btn @click="nextTab()" fab round color="primary"
                      ><v-icon>navigate_next</v-icon></v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-card>
            </v-tab-item>
            <v-tab-item key="gate_step_6">
              <v-card flat>
                <div class="row">
                  <div class="col-md-12">
                    <table
                      cellpadding="1"
                      cellspacing="1"
                      class="table table-bordered"
                    >
                      <thead>
                        <tr>
                          <td>Entry</td>
                          <td>Guests</td>
                          <td>Total Amount</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="gate_pass.organisation_type === '8D7E6504'">
                          <td>
                            <b>Conservation Fees </b>
                            <small>
                              for
                              {{
                                getDays(gate_pass.check_in, gate_pass.check_out)
                              }}
                              days</small
                            >
                          </td>
                          <td>{{ getGroupGuests() }}</td>
                          <td>
                            {{ $localCurrency }}
                            {{ schoolConservationTotal.toLocaleString("en") }}
                          </td>
                        </tr>
                        <tr v-if="gate_pass.organisation_type === 'C3237489'">
                          <td>
                            <b>Conservation Fees </b
                            ><small
                              >for
                              {{
                                getDays(gate_pass.check_in, gate_pass.check_out)
                              }}
                              days</small
                            >
                          </td>
                          <td>{{ getCoservationGuests() }}</td>
                          <td>
                            {{ $localCurrency }}
                            {{ conservationTotal.toLocaleString("en") }}
                          </td>
                        </tr>
                        <tr>
                          <table
                            v-if="gate_pass.organisation_type === '8D7E6504'"
                          >
                            <thead>
                              <tr>
                                <td>Residency</td>
                                <td>No of guests</td>
                                <td>Amount</td>
                                <td>Discount</td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(
                                  c_fees, idx
                                ) in allSchoolConservationFees"
                                :key="'c_fee' + idx"
                              >
                                <td v-if="c_fees.payment_guests > 0">
                                  {{ c_fees.payment_person }}
                                </td>
                                <td v-if="c_fees.payment_guests > 0">
                                  {{ c_fees.payment_guests }}
                                </td>
                                <td v-if="c_fees.payment_guests > 0">
                                  {{ $localCurrency }}
                                  {{
                                    $roundOff(
                                      convert1(
                                        c_fees.payment_person_currency,
                                        c_fees.payment_person_amount
                                      ).amount.toFixed(2)
                                    )
                                  }}
                                </td>
                                <td v-if="c_fees.payment_guests > 0">
                                  {{ c_fees.payment_person_discount }}%
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <table
                            v-if="gate_pass.organisation_type === 'C3237489'"
                          >
                            <thead>
                              <tr>
                                <td>Residency</td>
                                <td>No of guests</td>
                                <td>Amount</td>
                                <td>Discount</td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(c_fees, idx) in allConservationFees"
                                :key="'c_fee' + idx"
                              >
                                <td v-if="c_fees.payment_guests > 0">
                                  {{ c_fees.payment_person }}
                                </td>
                                <td v-if="c_fees.payment_guests > 0">
                                  {{ c_fees.payment_guests }}
                                </td>
                                <td v-if="c_fees.payment_guests > 0">
                                  {{ $localCurrency }}
                                  {{
                                    $roundOff(
                                      convert1(
                                        c_fees.payment_person_currency,
                                        c_fees.payment_person_amount
                                      ).amount.toFixed(2)
                                    )
                                  }}
                                </td>
                                <td v-if="c_fees.payment_guests > 0">
                                  {{ c_fees.payment_person_discount }}%
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </tr>
                        <tr>
                          <td>
                            <b>Vehicle Fees </b>for
                            {{
                              getDays(gate_pass.check_in, gate_pass.check_out)
                            }}
                            days
                          </td>
                          <td>{{ getVehicleTotals() }}</td>
                          <td>{{ $localCurrency }} {{ vehicleTotal }}</td>
                        </tr>
                        <tr>
                          <table>
                            <thead>
                              <tr>
                                <td>Vehicle Type</td>
                                <td>No of Vehicles</td>
                                <td>Amount</td>
                                <td>Discount</td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(v_fees, idx) in allVehicles"
                                :key="'v_fee' + idx"
                              >
                                <td v-if="v_fees.vehicles > 0">
                                  {{ v_fees.vehicle_charge_category }}
                                </td>
                                <td v-if="v_fees.vehicles > 0">
                                  {{ v_fees.vehicles }}
                                </td>
                                <td v-if="v_fees.vehicles > 0">
                                  {{ $localCurrency }}
                                  {{
                                    $roundOff(
                                      convert1(
                                        v_fees.vehicle_charge_cost_currency,
                                        v_fees.vehicle_charge_category_cost
                                      ).amount
                                    )
                                  }}
                                </td>
                                <td v-if="v_fees.vehicles > 0">
                                  {{ v_fees.discount }}%
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </tr>
                        <tr>
                          <td><b>Accommodation</b></td>
                        </tr>
                        <tr
                          v-for="(accommodation, key) in chosenFacilities"
                          :key="'acc' + key"
                        >
                          <td>{{ accommodation.name }}</td>
                          <td>
                            {{
                              Number(accommodation.children) +
                              Number(accommodation.adults) +
                              Number(accommodation.extra_pax_children) +
                              Number(accommodation.extra_pax_adults)
                            }}
                          </td>
                          <td>
                            {{ $localCurrency }}
                            {{ $roundOff(facilityTotal(accommodation)) }}
                          </td>
                        </tr>

                        <tr></tr>
                        <tr v-if="bookedFacilities.length > 0"></tr>
                        <tr
                          v-for="(accommodation, index) in bookedFacilities"
                          :key="'acck' + index"
                        >
                          <td>{{ accommodation.facility_name }}</td>
                          <td>
                            {{
                              Number(accommodation.facility_booking_children) +
                              Number(accommodation.facility_booking_adults)
                            }}
                          </td>
                          <td>
                            {{ accommodation.facility_booking_currency }}
                            {{ oldFacilityTotal(accommodation) }}
                          </td>
                        </tr>

                        <tr></tr>
                        <tr>
                          <td><b>Ol Pejeta Escapes</b></td>
                        </tr>
                        <tr v-if="chosenExternalFacilities.length > 0"></tr>
                        <tr
                          v-for="(
                            accommodation, index
                          ) in chosenExternalFacilities"
                          :key="'acc' + index"
                        >
                          <td>
                            {{ accommodation.name }}({{
                              accommodation.facility_parameter_name
                            }})
                          </td>
                          <td>{{ totalExternalGuest(accommodation) }}</td>
                          <td>
                            {{ $localCurrency }}
                            {{
                              $roundOff(externalFacilityTotal(accommodation))
                            }}
                          </td>
                        </tr>

                        <tr></tr>
                        <tr v-if="finExternalFacilities.length > 0"></tr>
                        <tr
                          v-for="(
                            accommodation, index
                          ) in finExternalFacilities"
                          :key="'acc' + index"
                        >
                          <td>
                            {{ accommodation.facility_name }}({{
                              accommodation.pricing_parameter.parameter_name
                            }})
                          </td>
                          <td>{{ totalOldExternalGuest(accommodation) }}</td>
                          <td>
                            {{ $localCurrency }}
                            {{
                              $roundOff(
                                convert1(
                                  accommodation.facility_booking_currency,
                                  accommodation.facility_booking_total_cost
                                ).amount
                              )
                            }}
                          </td>
                        </tr>

                        <tr></tr>

                        <tr></tr>
                        <tr>
                          <td><b>Activities</b></td>
                        </tr>
                        <tr
                          v-for="(activity, key) in chosenInventory"
                          :key="'act' + key"
                        >
                          <td>{{ activity.name }}</td>
                          <td>
                            {{
                              Number(activity.children) +
                              Number(activity.adults) +
                              Number(activity.extra_pax_children) +
                              Number(activity.extra_pax_adults)
                            }}
                          </td>
                          <td>
                            {{ $localCurrency }}
                            {{ $roundOff(findActivityTotal(activity)) }}
                          </td>
                        </tr>

                        <tr></tr>
                        <tr v-if="bookedInventory.length > 0"></tr>
                        <tr
                          v-for="(activity, index) in bookedInventory"
                          :key="'ac' + index"
                        >
                          <td>{{ activity.inventory_name }}</td>
                          <td>
                            {{
                              Number(activity.inventory_booking_children) +
                              Number(activity.inventory_booking_adults) +
                              Number(
                                activity.inventory_booking_extra_children
                              ) +
                              Number(activity.inventory_booking_extra_adults)
                            }}
                          </td>
                          <td>
                            {{ activity.inventory_booking_currency }}
                            {{
                              $roundOff(activity.inventory_booking_total_cost)
                            }}
                          </td>
                        </tr>
                        <!-- </tr> -->
                        <tr v-if="proofOfResidency.length > 0">
                          <td>
                            <b>Proof Of residency </b>
                          </td>
                        </tr>
                        <tr v-if="proofOfResidency.length > 0">
                          <table>
                            <thead>
                              <tr>
                                <td>First Name</td>
                                <td>Last Name</td>
                                <td>Residency</td>
                                <td>Document Id</td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(proof, idx) in proofOfResidency"
                                :key="'proof' + idx"
                              >
                                <td
                                  v-if="
                                    proof.first_name != '' &&
                                    proof.last_name != '' &&
                                    proof.document_id != ''
                                  "
                                >
                                  {{ proof.first_name }}
                                </td>
                                <td
                                  v-if="
                                    proof.first_name != '' &&
                                    proof.last_name != '' &&
                                    proof.document_id != ''
                                  "
                                >
                                  {{ proof.last_name }}
                                </td>
                                <td
                                  v-if="
                                    proof.first_name != '' &&
                                    proof.last_name != '' &&
                                    proof.document_id != ''
                                  "
                                >
                                  {{ proof.payment_person }}
                                </td>
                                <td
                                  v-if="
                                    proof.first_name != '' &&
                                    proof.last_name != '' &&
                                    proof.document_id != ''
                                  "
                                >
                                  {{ proof.document_id }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </tr>
                        <tr>
                          <td>
                            <b>Destination : </b>
                            {{ this.gate_pass.destination_name }}
                          </td>
                        </tr>
                        <tr>
                          <td><h2>Total</h2></td>
                          <td></td>
                          <td>
                            <h2>
                              {{ $localCurrency }}
                              {{ totalPrice.toLocaleString("en") }}
                            </h2>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col-md-6" style="margin-left: 1%">
                    <div class="form-gate_pass">
                      <div
                        class="col-md-4 col-lg-offset-2"
                        v-if="route === 'EditBooking'"
                      >
                        <v-switch
                          v-model="gate_pass.send_mail"
                          label="Send Email to client"
                        >
                        </v-switch>
                      </div>
                      <div class="col-sm-8">
                        <v-btn
                          :depressed="true"
                          color="primary"
                          v-if="route === 'NewBooking'"
                          @click.prevent="doBooking()"
                          :loading="this.$store.state.LoadingStore.loading"
                          >Complete Booking</v-btn
                        >
                        <v-btn
                          :depressed="true"
                          color="error"
                          v-if="route === 'EditBooking'"
                          @click.prevent="editBooking()"
                          :loading="this.$store.state.LoadingStore.loading"
                          >Amend Booking</v-btn
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </v-card>
              <v-snackbar
                :multi-line="true"
                :right="true"
                :vertical="true"
                :timeout="6000"
                color="error"
                v-model="snackbar"
              >
                Destination must be provided
                <v-btn flat @click="snackbar = false"> Close </v-btn>
              </v-snackbar>
            </v-tab-item>
          </v-tabs>
        </div>
      </div>
    </div>
    {{ updateGroupBooking }}
    {{ conservationFeesProofData }}
    

  </div>
</template>

<script>
import FacilityBooking from "./FacilityBooking";
import Datepicker from "vuejs-datepicker";
import InventoryBooking from "./InventoryBooking";
import ConservationFees from "./ConservationFees";
import VehicleFees from "./VehicleFees";
import ResidencyProof from "./ResidencyProof";
export default {
  components: {
    VehicleFees,
    ConservationFees,
    InventoryBooking,
    FacilityBooking,
    Datepicker,
    "residency-proof": ResidencyProof,
  },
  name: "gate_pass-booking",
  data() {
    return {
      route: this.$route.name,

      start_date: this.$moment().format("YYYY-MM-DD"),
      today: this.$moment().format("YYYY-MM-DD"),
      backdate_today: this.$moment().subtract(7, "d").format("YYYY-MM-DD"),
      active: null,
      requiredRules: [(v) => !!v || "This field is required"],
      snackbar: true,
      menu1: false,
      modal1: false,
      menu2: false,
      modal2: false,
      gate_pass: {
        code: "",
        school: {
          school_id: "",
          primary_contact: "",
          primary_contact_email: "",
          primary_contact_phone: "",
          secondary_contact: "",
          secondary_contact_email: "",
          secondary_contact_phone: "",
          promo_code: "",
          destination: "",
          destination_name: "",
          note: "",
        },
        type: "FF9330A3",
        send_mail: "",
        note: "",
        check_in: this.$moment().format("YYYY-MM-DD"),
        check_out: this.$moment().format("YYYY-MM-DD"),
        currency: this.$store.state.CurrencyStore.browser_currency_id,
        currency_id: "",
        organisation_name: "",
        organisation_email: "",
        organisation_type: "",
        name: "",
        email: "",
        phone: "",
        kra_pin_number: "",
        session_id: localStorage.getItem("lkjhgfdsa"),
      },
      selectAccomodation: [],
      selectedActivities: [],
    };
  },
  created() {
    this.$store.dispatch("get_all_group_booking_types");
    this.$store.dispatch("all_school_conservation_fees");
    this.$store.dispatch("get_all_genders2");
    this.$store.dispatch("get_all_destinations");
    this.$store.dispatch("fetch_all_schools");
  },
  computed: {
    currency: function () {
      return this.$store.state.CurrencyStore.browser_currency;
    },
    totalPrice: function () {
      // activity total
      var activity = 0;
      if (this.chosenInventory.length > 0) {
        for (var i = 0; i < this.chosenInventory.length; i++) {
          activity = activity + this.findActivityTotal(this.chosenInventory[i]);
        }
      }
      if (this.bookedInventory.length > 0) {
        for (var x = 0; x < this.bookedInventory.length; x++) {
          activity =
            activity + this.findOldActivityTotal(this.bookedInventory[x]);
        }
      }
      // facility total
      var facility = 0;
      var external_facility = 0;
      var old_external_facility = 0;
      if (this.chosenFacilities.length > 0) {
        for (var j = 0; j < this.chosenFacilities.length; j++) {
          facility = facility + this.facilityTotal(this.chosenFacilities[j]);
        }
      }
      if (this.bookedFacilities.length > 0) {
        for (var f = 0; f < this.bookedFacilities.length; f++) {
          facility = facility + this.oldFacilityTotal(this.bookedFacilities[f]);
        }
      }
      if (this.chosenExternalFacilities.length > 0) {
        for (var k = 0; k < this.chosenExternalFacilities.length; k++) {
          external_facility =
            external_facility +
            this.externalFacilityTotal(this.chosenExternalFacilities[k]);
        }
      }
      if (this.finExternalFacilities.length > 0) {
        for (var m = 0; m < this.finExternalFacilities.length; m++) {
          let amount = this.convert1(
            this.finExternalFacilities[m].facility_booking_currency,
            this.finExternalFacilities[m].facility_booking_total_cost
          ).amount;
          old_external_facility = old_external_facility + amount;
        }
      }

      // vehicle total
      var vehicleData = this.vehicleTotal;
      // conservation total
      // var conservationData = this.conservationTotal;
      var conservationData
      if (this.gate_pass.organisation_type === '8D7E6504') {
        conservationData = this.schoolConservationTotal
        

      } else {
        
        conservationData = this.conservationTotal
        

      }
      return Math.ceil(
        Number(activity) +
          Number(facility) +
          vehicleData +
          conservationData +
          Number(external_facility) +
          Number(old_external_facility)
      );
    },

    disabled_settings: function () {
      var startDate = this.$moment().format("YYYY-MM-DD");
      return {
        to: new Date(this.$moment(startDate).format("YYYY, MM, DD")),
      };
    },
   
  },
  methods: {
    nextTab() {
      this.active = Number(this.active + 1);
    },
    previousTab() {
      this.active = Number(this.active - 1);
    },

    onSchoolSelect(schoolPublicId) {
  const selectedSchool = this.$allSchools.find(
    school => school.school_public_id === schoolPublicId
  );
  
  if (selectedSchool) {
    this.gate_pass.kra_pin_number = selectedSchool.kra_pin || '';
    
    this.gate_pass.school.primary_contact = selectedSchool.primary_contact || '';
    this.gate_pass.school.primary_contact_email = selectedSchool.primary_contact_email || '';
    this.gate_pass.school.primary_contact_phone = selectedSchool.primary_contact_phone || '';
    this.gate_pass.school.secondary_contact = selectedSchool.secondary_contact || '';
    this.gate_pass.school.secondary_contact_email = selectedSchool.secondary_contact_email || '';
    this.gate_pass.school.secondary_contact_phone = selectedSchool.secondary_contact_phone || '';
  }
},
    checkDestination(publicId) {

      var data = {
        check_in_date: this.gate_pass.check_in,
        check_out_date: this.gate_pass.check_out,
        destination: this.gate_pass.destination,
      };
      if (this.gate_pass.organisation_type === "8D7E6504") {
        // School Based Pricing
        this.$store.dispatch("get_newly_scheduled_school_pricing", data);
      } else {
        // General Pricing Schedule
        this.$store.dispatch("get_newly_scheduled_pricing", data);
      }
      var instance = this;
      this.allDestinations.map((destination) => {
        if (publicId === destination.destination_public_id) {
          instance.gate_pass.destination_name = destination.destination_name;
        }
      });
    },
    getVehicleTotals: function () {
      var allVehicles = this.allVehicles;
      var size = allVehicles.length;
      var vehicles = 0;
      for (var i = 0; i < size; i++) {
        vehicles = Number(vehicles) + Number(allVehicles[i].vehicles);
      }
      return vehicles;
    },
    putFacilityData: function (data) {
      this.selectAccomodation = data;
    },
    putActivityData: function (data) {
      this.selectedActivities = data;
    },
    doBooking: function () {
      if (this.gate_pass.destination === "") {
        this.snackbar = true;
      } else {
        this.$store.dispatch("loading_true");
        this.gate_pass.currency_id =
          this.$store.state.CurrencyStore.browser_currency_id;
        this.gate_pass.currency =
          this.$store.state.CurrencyStore.browser_currency_id;
        var data;
        if (this.gate_pass.organisation_type === "8D7E6504") {
          data = {
            guests: this.allSchoolConservationFees,
            facilities: this.chosenFacilities,
            external_facilities: this.chosenExternalFacilities,
            inventory: this.chosenInventory,
            vehicles: this.allVehicles,
            multi: this.addedMultiArrivals,
            proof_of_residency: this.proofOfResidency,
          };
        } else {
          data = {
            guests: this.allConservationFees,
            facilities: this.chosenFacilities,
            external_facilities: this.chosenExternalFacilities,
            inventory: this.chosenInventory,
            vehicles: this.allVehicles,
            multi: this.addedMultiArrivals,
            proof_of_residency: this.proofOfResidency,
          };
        }
        Object.assign(data, this.gate_pass);
        if (this.$route.name === "NewBooking") {
          this.$store.dispatch("post_group_booking", data);
        } else {
          this.$store.dispatch("update_group_booking", data);
        }
      }
    },
    editBooking: function () {
      this.$store.dispatch("loading_true");
      this.gate_pass.currency_id =
        this.$store.state.CurrencyStore.browser_currency_id;
      this.gate_pass.currency =
        this.$store.state.CurrencyStore.browser_currency_id;
      var data = {
        booking_id: this.$route.params.booking_id,
        guests: this.allSchoolConservationFees,
        facilities: this.chosenFacilities,
        external_facilities: this.chosenExternalFacilities,
        inventory: this.chosenInventory,
        vehicles: this.allVehicles,
        multi: this.addedMultiArrivals,
        old_facilities: this.bookedFacilities,
        old_inventory: this.bookedInventory,
        old_external_facilities: this.finExternalFacilities,
        updated_bookings: this.bookedFacilities,
        proof_of_residency: this.proofOfResidency,
      };

      Object.assign(data, this.gate_pass);
      this.$store.dispatch("update_group_booking", data);
    },
    putStartDate: function () {
      var date = this.gate_pass.check_in;
      date = this.$moment(date).format("YYYY-MM-DD");
      this.gate_pass.check_in = date;
    },
    putEndtDate: function () {
      var date = this.gate_pass.check_out;
      date = this.$moment(date).format("YYYY-MM-DD");
      this.gate_pass.check_out = date;
    },
    currencyChange: function () {
      var data = this.currency;
      localStorage.setItem("currency", data);
      this.$store.state.CurrencyStore.browser_currency = data;
    },
    findCountryCode(data) {
      var instance = this;
      this.allCountries.map(function (country) {
        if (data === country.code) {
          instance.gate_pass.school.primary_contact_phone =
            "+" + country.calling_code;
          instance.gate_pass.school.secondary_contact_phone =
            "+" + country.calling_code;
          instance.gate_pass.phone = "+" + country.calling_code;
        }
      });
    },
  },
};
</script>

<style scoped>
</style>
